import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ContentCard } from "@shared";
import { FormikProps } from "formik";

import { IOptionItem } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete.types";
import { CounselorDutyPreferencesFormValues } from "@/pages/system-settings/tabs/counselors/pages/counselor-detail/pages/duty-preferences/CounselorDutyPreferences.types";
import { useTranslation } from "@/translations";

import { BlockedPeriodRow } from "../blocked-period-row/BlockedPeriodRow";

interface Props {
  formik: FormikProps<CounselorDutyPreferencesFormValues>;
  dutyTypeOptions: IOptionItem[];
  onAdd: () => void;
  onDelete: (index: number) => void;
}

export function BlockedPeriodsCard({ formik, dutyTypeOptions, onAdd, onDelete }: Props) {
  const { t } = useTranslation();

  return (
    <ContentCard title={t("counselors.dutyPreferences.blockedPeriods.title")}>
      <Stack gap={2}>
        <Typography variant="body2">{t("counselors.dutyPreferences.blockedPeriods.hint")}</Typography>

        {formik.values.blockedPeriods.map((blockedPeriod, index) => (
          <BlockedPeriodRow
            key={blockedPeriod.id ?? `new-${index}`}
            formik={formik}
            index={index}
            dutyTypeOptions={dutyTypeOptions}
            onDelete={() => onDelete(index)}
          />
        ))}

        <Box>
          <Button variant="text" size="small" startIcon={<AddIcon />} onClick={onAdd}>
            {t("counselors.dutyPreferences.blockedPeriods.addButton")}
          </Button>
        </Box>
      </Stack>
    </ContentCard>
  );
}
